import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import jLouvain from '../lib/jLouvain'
import * as _ from 'lodash'
import d3 from 'd3'
import PinchZoom from './PinchZoom.js'
global.d3 = d3
global.jLouvain = jLouvain

// var edge_data = _.flatten(quark.graph.nodes().map(k => quark.edges(k).map(e => ({ source: k.id, target: e.ref, weight: 1 }))))
// var node_data = quark.graph.nodes().map(k => k.id)


function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

function modularityCensus(nodes, edges, moduleHash) {
  edges.forEach(function (edge) {
    if (edge.source.module !== edge.target.module) {
      edge.border = true;
    }
    else {
      edge.border = false;
    }
  });
  nodes.forEach(function (node) {
    var theseEdges = edges.filter(function(d) {return d.source === node || d.target === node});

    var theseSourceModules = theseEdges.map(function (d) {return d.source.module}).filter(onlyUnique);
    var theseTargetModules = theseEdges.map(function (d) {return d.target.module}).filter(onlyUnique);

    node.degree = theseSourceModules.length + theseTargetModules.length
    if (theseSourceModules.length > 1 || theseTargetModules.length > 1) {
      node.border = true;
    }
    else {
      node.border = false;
    }
  });

  var modules = nodes.map(function (d) {return d.module})
  .filter(onlyUnique)
  .map(function (d) {return {id: d, members: []}});

  var moduleEdges = [];
  var singletons = {id: "singletons", members: []};

  var moduleNodeHash = {};

  modules.forEach(function (module) {
    module.members = nodes.filter(function (d) {return d.module === module.id});
    moduleNodeHash[module.id] = module;
    if (module.members.length === 1) {
      singletons.members.push(module.members[0]);
    }
  });

  modules.push(singletons);

  var moduleEdgeHash = {};

  edges.forEach(function (edge) {

    if (!moduleEdgeHash[moduleNodeHash[edge.source.module].id + "-" + moduleNodeHash[edge.target.module].id]) {
      var moduleEdge = {source: moduleNodeHash[edge.source.module], target: moduleNodeHash[edge.target.module], weight: 1};
      moduleEdgeHash[moduleNodeHash[edge.source.module].id + "-" + moduleNodeHash[edge.target.module].id] = moduleEdge;
      moduleEdges.push(moduleEdge);
    }
    else {
      moduleEdgeHash[moduleNodeHash[edge.source.module].id + "-" + moduleNodeHash[edge.target.module].id].weight += 1;
    }
  })


  return {nodes: modules, edges: moduleEdges}

}




function wrap(text, width) {
  text.each(function() {
    var text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1, // ems
        y = text.attr("y"),
        dy = parseFloat(text.attr("dy")),
        tspan = text.text(null)
          .append("tspan")
          .attr("x", 0)
          .attr("y", y)
          .attr("dy", dy + "em");
    while (word = words.pop()) {
      line.push(word);
      tspan.text(line.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text.append("tspan")
          .attr("x", 0)
          .attr("y", y)
          .attr("dy", ++lineNumber * lineHeight + dy + "em")
          .text(word);
      }
    }
  });
}



export default class Graph extends Component {
    componentWillUnmount(){
        if(this.force) this.force.stop();
    }
    componentDidMount(){
        setTimeout(e => {
            this.instantiateD3()
        }, 10)
    }
    instantiateD3(){
        var el = ReactDOM.findDOMNode(this);
        
var margin = {top: -5, right: -5, bottom: -5, left: -5},
    width = innerWidth - margin.left - margin.right,
    height = innerHeight - margin.top - margin.bottom;


// var tx = width/3, ty = height/31;

var zoom = d3.behavior.zoom()
    .scaleExtent([0.1, 10])
    .translate([0, 0])
    .scale(1)
    .on("zoom", zoomed);


var colors = d3.scale.category20();
var edgecolors = d3.scale.category20b()


var svg = d3.select(el).append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
  .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.right + ")")
    .call(zoom)
    // .call(PinchZoom);

PinchZoom(svg, zoom, zoomed)

var rect = svg.append("rect")
    .attr("width", width)
    .attr("height", height)
    .style("fill", "none")
    .style("pointer-events", "all");

var container = svg.append("g");

container.attr("transform", "translate(" + zoom.translate().join(',') + ")scale(" + zoom.scale() + ")");



var nodes = quark.graph.nodes().map((k, i) => ({ id: k.id, text: k.text, index: i, incoming: [], outgoing: [] }))
var nodemap = _.object(nodes.map(k => [k.id, k]))

var edgestuff = _.flatten(quark.graph.nodes().map(k => quark.edges(k).map(e => 
    ({ 
      source: nodemap[k.id], 
      target: nodemap[e.ref],
      predicate:  quark.canonicalize_pair(quark.get(e.parent).predicate),
      weight: 1, id: e.id })
    ).filter(k => k.source && k.target)))

var node_data = nodes.map(function (d) {return d.id});
var edge_data = edgestuff.map(function (d) {
  return {source: d.source.id, target: d.target.id, weight: 1}; 
});
var community = jLouvain().nodes(node_data).edges(edge_data)

var result = community()

nodes.forEach(function(node){
    node.module = result[node.id]
})


edgestuff.forEach(k => {
  k.source.outgoing.push(k)
  k.target.incoming.push(k)
})

var modularityGraph = modularityCensus(nodes.filter(k => 
  k.incoming.length > 0 || k.outgoing.length > 0), edgestuff, result);

var modulo = container.append("g")

var internal = container.append('g')


  var mouseOver; 
  
function zoomed() {
  container.attr("transform", "translate(" + zoom.translate() + ")scale(" + zoom.scale() + ")");

  // [tx, ty] = d3.event.translate
  // scale = d3.event.scale

  // console.log(tx, ty, scale)
  updateInterior()
  mouseOver = null;

}


var exitGraphView = this.props.exitGraphView.bind(this);

function clickNode(d){
    // console.log(this, d3.select(this).datum(), d3.event, d)
    // this.props.exitGraphView()
    exitGraphView()
    quark.set_text(undefined, quark.root(), quark.tok(d.id))
    quark.checkpoint()
    globalUpdate()

}

  function moduleOver(bigd) {
    // console.log("MODULE", d);
    // d3.select(this).style("r", 12)

    mouseOver = bigd.id;
    // container.selectAll("g.node")
    //   .attr('opacity', function(d){
    //     return d.id == bigd.id
    //   })

    updateInterior()
    
  }

  function moduleOut(d) {
    // d3.select(this)
    // .style("r", 8)

    mouseOver = null;
    updateInterior()
    
  }



function updateInterior(){
  var scale = zoom.scale(),
      [tx, ty] = zoom.translate();

var logScale = Math.log(scale)
// logScale = 10
// console.log(scale, logScale)
var vmap = {}

if(logScale > -0.3){
    var visible = nodes.filter(k => k.x > -tx / scale && k.y > -ty/scale &&
        k.x < (-tx + width) / scale && k.y < (-ty + height)/scale)


    visible.forEach(k => vmap[k.id] = k)

    var vedges = []
    visible.forEach(k => {
      vedges = vedges.concat(k.incoming)
      vedges = vedges.concat(k.outgoing)
    })

    vedges = _.uniq(vedges, k => k.id)



    // var vedges = edgestuff.filter(k => vmap[k.source.id] || vmap[k.target.id] )


}else{
    var visible  = []
    var vedges = []
}


modulo.selectAll('.modularity')
    .style('opacity',  1/(1+Math.pow(Math.E, -(   (-logScale) * 10 )))  )

    // modulo.selectAll('.circularity')
modulo.selectAll('.convexity')
    .style('opacity',  1/(1+Math.pow(Math.E, -(   (-logScale) * 10 ))) * 0.7 + 0.2    )
// console.log(tx, ty, scale, visible)


 // && k.x < (tx + width) / scale && 
 //                    k.y > ty / scale && k.y < (ty + height) / scale)


var veggie = internal.selectAll("g.edge")
.data(vedges, function (d) {return d.id})

var edgeEnter = veggie
  .enter()
  .append("g")
  .attr("class", "edge")
  .append("line")
  // .style("opacity", 0.5)
  .style("stroke", function(d){
    return edgecolors(d.predicate)
  })
  .style("pointer-events", "none");

veggie.exit().remove();


// veggie.attr('data-stuff', function(d){
//   return d.source.id + '-' + d.target.id
// })

// veggie.attr('data-id', function(d){
//   return d.id
// })

veggie.selectAll('line')
    .attr("x1", function (d) {return d.source.x})
    .attr("y1", function (d) {return d.source.y})
    .attr("x2", function (d) {return d.target.x})
    .attr("y2", function (d) {return d.target.y});


var vNodes = container.selectAll("g.node")
    .data(visible, function (d) {return d.id});

var nodeEnter = vNodes
    .enter()
    .append("g")
    .attr("class", "node")
  // .call(force.drag());

nodeEnter
    .append("circle")
    .style("stroke", "black")
    .on("mouseover", moduleOver)
    .on("mouseout", moduleOut)
    .on("dblclick", clickNode)


vNodes.exit().remove();

var nodeOpacity = 1/(1+Math.pow(Math.E, -(   (logScale) * 20 ))) 

var explored = {}

if(mouseOver && vmap[mouseOver] && nodeOpacity > 0.3){
  var vmo = vmap[mouseOver];

  var queue = [vmo];
  vmo.distance = 0;
  while(queue.length > 0){
    var node = queue.shift();
    _.pluck(node.incoming, 'source').concat(
      _.pluck(node.outgoing, 'target')
    ).forEach(k => {
      if(!(k.id in explored)){
        explored[k.id] = true;
        k.distance = node.distance + 1;
        queue.push(k)
      }
    })

  }

}


vNodes
    .attr("transform", function (d) {return "translate(" + d.x + "," + d.y + ")"})
    .style("opacity", function(d){
      if(mouseOver){
        if(explored[d.id]){
          return Math.pow(0.3, Math.max(0, d.distance - 2) ) * nodeOpacity
        }
        return 0.01 * nodeOpacity
      }
      return nodeOpacity
    })


veggie
  .style("opacity", function(d){
      if(mouseOver){
        var mind = Math.max(explored[d.source.id] ? d.source.distance : 100,
                explored[d.target.id] ? d.target.distance : 100)

        return Math.max(Math.pow(0.3, Math.max(0, mind - 2) ), 0.01 * nodeOpacity)
        // return ((d.source.id == mouseOver || d.target.id == mouseOver) ? 1 : 0.3) * nodeOpacity
      }
      return nodeOpacity
  })
veggie.selectAll('line')
  .style("stroke-width", function(d){
      if(mouseOver){
        var mind = Math.min(explored[d.source.id] ? d.source.distance : 100,
                explored[d.target.id] ? d.target.distance : 100)

        return 4 / (1 + mind)
      }
      return 1
  })

vNodes
.selectAll("circle")

.attr("r", function(d){ 
  var base = Math.sqrt(d.incoming.length + d.outgoing.length) + 3 ;
  return base + (d.id == mouseOver ? 5 : 0);
})
.style("fill", function (d) {return colors(d.module)})
.style("stroke-width", "1px")
// .style("stroke-width", function (d) {return d.border ? "3px" : "1px"})

nodeEnter.append("text")
.attr("y", 3)
.attr('class', 'outer')

nodeEnter.append("text")

.attr("y", 3)
.attr('class', 'inner')
.text(function (d) {return d.text})


vNodes.selectAll('text')
.text(function (d) {return d.text})



}


console.log(modularityGraph)

modulo.selectAll("line")
  .data(modularityGraph.edges)
  .enter()
  .append("line")
  .attr("class", "modularity")
  .style("stroke-width", function (d) {return d.weight * 2})
  .style("stroke", "black");


modulo.selectAll('path.convexity')
    .data(modularityGraph.nodes.filter(function(d) {return d.members.length > 1}))
    .enter()
    .append('path')
    .attr('class', 'convexity')
    .style("stroke-width", "32px")
    .style("fill", d => colors(d.id))
    .style("stroke", d => colors(d.id))




var modEnter = modulo.selectAll("g.bignode")
    .data(modularityGraph.nodes.filter(function(d) {return d.members.length > 1}))
    .enter()
    .append('g')
    .attr('class', 'bignode')


// modEnter.append("circle")
//     .attr("class", "circularity")
//     .attr("r", function (d) {return 2 * d.members.length})
//     .style("stroke", "black")
//     .style("stroke-width", "1px")
//     .style("fill", function (d) {return colors(d.id)})

// modEnter.append("path")


function hullRadius(points){
  var hull = d3.geom.hull(points)
  var center = d3.geom.polygon(hull).centroid()
  return d3.min(hull.map(k => 
    Math.hypot(k[0] - center[0], k[1] - center[1]) ))
}

modEnter.append("text")
    .style("text-anchor", "middle")
    .attr("class", "modularity outer")
    // .attr("y", function(d){
    //     return -Math.pow(d.members.length, 0.8) * 1.6
    // })
    .attr("y", 0)
    .attr("dy", 0)
    .style('font-size', '1em')
    .style('stroke-width', '0.1em')
    // .style("font-size", function(d){
    //     // var radius = hullRadius(d.members.map(k => [k.x, k.y]))

    //     // return (radius/50) + 'px'
    //     return (Math.pow(d.members.length, 0.8)) + "px"
    // })
    // .style("stroke-width", function(d){
    //     return Math.max(1, (Math.pow(d.members.length, 0.8))/8) + "px"
    // })
    .text(function (d) {
        return _.sortBy(d.members, k => -(k.incoming.length + k.outgoing.length))
        .slice(0, 3).map(k => k.text).join(', ')
    })
    .call(wrap, 100)
    .style("pointer-events", "none")


modEnter.append("text")
    .style("text-anchor", "middle")
    .attr("class", "modularity inner")
    // .attr("y", function(d){
    //     return -Math.pow(d.members.length, 0.8) * 1.6
    // })
    .attr("y", 0)
    .attr("dy", 0)
    .style('font-size', '1em')
    // .style("font-size", function(d){
    //     return (Math.pow(d.members.length, 0.8)) + "px"
    //     // var radius = hullRadius(d.members.map(k => [k.x, k.y]))

    //     // return (radius/50) + 'px'
    // })
    .text(function (d) {
        return _.sortBy(d.members, k => -(k.incoming.length + k.outgoing.length))
        .slice(0, 3).map(k => k.text).join(', ')
    })
    .call(wrap, 100)
    .style("pointer-events", "none")


var force = d3.layout.force().nodes(nodes).links(edgestuff)
.size([width, height])
.charge(-300)
.linkDistance(30)
.gravity(0.1)
force.start();


for(var i = 0; i < 150; i++){
  force.tick()
}

var xExtent = d3.extent(d3.values(nodes), function(n) { return n.x; }),
    yExtent = d3.extent(d3.values(nodes), function(n) { return n.y; });

var scaleX = (xExtent[1] - xExtent[0]) / width;
var scaleY = (yExtent[1] - yExtent[0]) / height;
zoom.scale(1/Math.max(scaleX, scaleY) * 0.8)
// zoom.scale(1)


console.log('width', (xExtent[0] + xExtent[1])/2, width)
zoom.translate([
  width/2 + (-xExtent[0]-(xExtent[1]-xExtent[0])/2) * zoom.scale(),
  height/2 + (-yExtent[0]-(yExtent[1]-yExtent[0])/2) * zoom.scale()
  // -xExtent[0],
  // -yExtent[0]
  // ((xExtent[0] + xExtent[1])/2 - width/2),
  // ((yExtent[0] + yExtent[1])/2 - height/2)
])



// zoom.translate([
// console.log( xExtent[0], yExtent[0])

// console.log(Math.max(scaleX, scaleY))
// var scale = 1 / Math.max(scaleX, scaleY);

// var translateX = Math.abs(xExtent[0]) * scale /2;
// var translateY = Math.abs(yExtent[0]) * scale / 2;

// console.log(scale, translateX, translateY)

// zoom.scale(scale)
// zoom.translate([translateX, translateY])



window.zoom = zoom;
window.nodes = nodes;

force
.on("tick", updateNetwork);

// force.tick()
updateNetwork()
zoomed()
// force.stop()

console.log(nodes)

this.force = force;

function hypot(x, y){
  return Math.sqrt(x*x + y * y)
}
function updateNetwork() {


// internal.selectAll("g.node")
//     .attr("transform", function (d) {return "translate(" + d.x + "," + d.y + ")"});

modulo.selectAll(".bignode")
.each(function (d) {
    var hull = d3.geom.hull(d.members.map(k => [k.x, k.y]))
    var poly = d3.geom.polygon(hull)
    var center = poly.centroid()

    d.x = center[0]
    d.y = center[1]

    // d.radius = d3.min(hull.map(k => hypot(k[0] - center[0], k[1] - center[1])))
    d.radius = Math.sqrt(poly.area()) / 3
    // var theseNodes = d.members;
    // var avgX = d3.mean(theseNodes, function (p) {return p.x});
    // var avgY = d3.mean(theseNodes, function (p) {return p.y});
    // d.x = avgX;
    // d.y = avgY;
})
.attr("transform", function (d) {
  return "translate(" + d.x + "," + d.y + ") scale(" + (d.radius/80) + ")"
});

modulo.selectAll(".convexity")
  .attr("d", function(d){
    return 'M' + d3.geom.hull(d.members.map(k => [k.x, k.y])).join('L') + 'Z'
  })


modulo.selectAll("line")
  .attr("x1", function (d) {return d.source.x})
  .attr("y1", function (d) {return d.source.y})
  .attr("x2", function (d) {return d.target.x})
  .attr("y2", function (d) {return d.target.y});


updateInterior()

}



    }
    render(){
        return <div className="graph-parent">
          <button className="toggleGraphView" onClick={e => {global.graphView = false; globalUpdate()}}>Exit Network View</button>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/react/Graph.jsx